// src/pages/LoginPage.js

import React, {useState} from 'react';
import '../style/css/login.css';
import utils from '../services/utils';
import Captchaaptcha from "./Captcha";
import managedata from '../services/managedata.js'
import RegisterUserHub from "./RegisterUserHub";
import CooldownButton from "./CooldownButton";
import ForgetPassComponent from "./ForgetPassComponent";
import logosidebar from "../style/imges/logosidebar.png";


const LoginPage = ({onLogin}) => {
    const [isRegister, setRegisterMode] = useState(false); //
    const [frogetPassMode, setFrogetPassMode] = useState(false); //
    const [enterySMS, setEnterySMS] = useState(''); //
    const [loginMethod, setLoginMethod] = useState(false); // 'username' or 'phone'
    const [phoneNumber, setPhoneNumber] = useState(localStorage.getItem('phone'));
    const [lorFname, setLorFname] = useState('');
    const [verificationCode, setVerificationCode] = useState('');
    const [otCode, setOtCode] = useState(utils.useLang('OTCODE')+ ' ' + utils.useLang('OTCODE_ASK'));
    const [password, setPassword] = useState(localStorage.getItem('pass'));
    const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
    const [isError, setError] = useState(false);


    const handlePhoneLogin = () => {
        // Implement phone number login logic here (send verification code to phone number)
        if (isValidPhoneNumber(phoneNumber)) {
            let data = {
                'data': {
                    'phone': phoneNumber,
                    'firstOrLastName': lorFname,
                },
                'type': {'act': 'sendOTP'}
            }
            managedata.sendData(data, failToOTP, handleSendSms)
            handleSendSms()
        }
    };
    const handleSendSms = () => {
        setVerificationCode(true);
    }

    const failToOTP = () => {
        setError(utils.useLang('FAIL_LOGIN_PHONE'))
    }

    // Function to validate phone number
    const isValidPhoneNumber = (phone) => {
        const isNumeric = /^\d+$/.test(phone);
        return isNumeric && phone.startsWith('05') && phone.length === 10;
    };

    const handleFailLogin = () => {
        setError(utils.useLang('LOGIN_ERROR'))
    }
    const handleBackMethod = () =>{
        setLoginMethod(false);
    }
    const handleVerifyCode = () => {
        // Implement code verification logic here
        let data = {
            'data': {
                'phone': phoneNumber,
                'otpCode': enterySMS,
            },
            'type': {'act': 'loginWithOTP'}
        }
        managedata.sendData(data, handleFailLogin, onLogin)
    };

    const handleUsernamePasswordLogin = () => {
        let data = {
            'data': {
                'phone': phoneNumber,
                'password': password,
            },
            'type': {'act': 'loginWithPass'}
        }
        managedata.sendData(data, handleFailLogin, onLogin)
        localStorage.setItem('phone', phoneNumber)
        localStorage.setItem('pass', password)
    };


    return (
        <>
            <section className={'login-sec'}>
                {/*<div className='air air1'></div>*/}
                {/*<div className='air air2'></div>*/}
                {/*<div className='air air3'></div>*/}
                {/*<div className='air air4'></div>*/}


                <div className="login-container">
                    <>
                        {isRegister ? (
                            <RegisterUserHub phoneNumber={phoneNumber} password={password} setPassword={setPassword}
                                             setPhoneNumber={setPhoneNumber} setRegisterMode={setRegisterMode}/>
                        ) : frogetPassMode ? (
                            <ForgetPassComponent
                                phoneNumber={phoneNumber}
                                setPhoneNumber={setPhoneNumber}
                                setForgetPassMode={setFrogetPassMode}
                            />
                        ) : (
                            <div className="login-box">
                                <img className={'logo-sidebar logo-reg'} src={logosidebar} alt="logo"/>

                                <h2 className={'login-title'}>{utils.useLang('LOGIN_HEAD')}</h2>
                                {!loginMethod  && <div className="switch-buttons">
                                    <button className={'login-btn'}
                                            onClick={() => setLoginMethod('username')}>{utils.useLang('USERNAME_LOGIN')}</button>
                                    <button className={'login-btn'}
                                            onClick={() => setLoginMethod('phone')}>{utils.useLang('PHONE_NUMBER_LOGIN')}</button>
                                </div>}
                                {loginMethod === 'username' && (
                                    <div>
                                        <input
                                            className={'login-inp'}
                                            type="text"
                                            placeholder={utils.useLang('PHONE_NUMBER')}
                                            value={phoneNumber}
                                            onChange={(e) => setPhoneNumber(e.target.value)}
                                        />
                                        <input
                                            className={'login-inp'}
                                            type="password"
                                            placeholder={utils.useLang('PASS')}
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                        />
                                        <div className={"new-account-contaiiner"}>
                                            <input type={"checkbox"} id={'saveLoginInfo'}/>
                                            <label htmlFor={'saveLoginInfo'}>{utils.useLang('SAVE_DETAILS')}</label>
                                        </div>

                                        <button className={'login-btn'}
                                                onClick={handleUsernamePasswordLogin}>{utils.useLang('LOGIN_BTN')}</button>
                                        {loginMethod && <button className={'login-btn'} onClick={handleBackMethod}>{utils.useLang('BACK')}</button>}
                                    </div>
                                )}
                                {loginMethod === 'phone' && (
                                    <div>
                                        {!verificationCode ? (
                                            <div>
                                                <input
                                                    className={'login-inp'}
                                                    type="text"
                                                    id={'phoneNumber'}
                                                    placeholder={utils.useLang('PHONE_NUMBER')}
                                                    value={phoneNumber}
                                                    onChange={(e) => setPhoneNumber(e.target.value)}
                                                />
                                                <input
                                                    className={'login-inp'}
                                                    type="text"
                                                    id={'FirstLastName'}
                                                    placeholder={utils.useLang('F_OR_L_NAME')}
                                                    value={lorFname}
                                                    onChange={(e) => setLorFname(e.target.value)}
                                                />
                                                <Captchaaptcha onVerify={setIsCaptchaVerified}/>
                                                {isCaptchaVerified && <button className={'login-btn'}
                                                                              onClick={handlePhoneLogin}>{utils.useLang('SEND_CODE')}</button>}
                                            </div>
                                        ) : (
                                            <>
                                                <div>
                                                    <span>{utils.useLang('CODE_SEND_TO')}</span>
                                                    <span>{phoneNumber}</span>
                                                </div>
                                                <input
                                                    className={'login-inp'}
                                                    type="text"
                                                    placeholder={utils.useLang('ENTER_CODE_SMS')}
                                                    value={enterySMS}
                                                    onChange={(e) => setEnterySMS(e.target.value)}
                                                />
                                                <button className={'login-btn'}
                                                        onClick={handleVerifyCode}>{utils.useLang('LOGIN_BTN')}</button>
                                                <CooldownButton
                                                    label={utils.useLang('SEND_CODE_AGAIN')}
                                                    onClick={handlePhoneLogin}
                                                />
                                            </>
                                        )}
                                        {loginMethod && <button className={'login-btn'} onClick={handleBackMethod}>{utils.useLang('BACK')}</button>}
                                    </div>
                                )}
                                {isError && <div> {isError}</div>}
                                <div>
                                    שכחת את הסיסמא?
                                    <button
                                        className="link-btn"
                                        onClick={() => setFrogetPassMode(true)}
                                        style={{
                                            background: 'none',
                                            border: 'none',
                                            color: 'rgba(206, 77, 156, 0.62)',
                                            cursor: 'pointer',
                                            textDecoration: 'underline'
                                        }}
                                    >
                                        {utils.useLang('RESET')}
                                    </button>
                                </div>
                                <div>
                                    {utils.useLang('NO_USER')}
                                    <button
                                        className="link-btn"
                                        onClick={() => setRegisterMode(true)}
                                        style={{
                                            background: 'none',
                                            border: 'none',
                                            color: 'rgba(206, 77, 156, 0.62)',
                                            cursor: 'pointer',
                                            textDecoration: 'underline'
                                        }}
                                    >
                                        {utils.useLang('REGISTER')}
                                    </button>
                                </div>
                            </div>)}
                    </>
                </div>
            </section>
        </>
    );
};

export default LoginPage;
